import React from 'react';
import { Table } from 'antd';
import ReducedData from '../../reducedData.json';
import dict from '../../dictionary';
import trans from '../../translations.json';

class StackedTable extends React.Component {
  state = {
    searchText: '',
    searchedColumn: '',
    data: undefined,
  };

  render() {
    const cData = Object.values(ReducedData.dataSex);

    var tableData = cData.map((item, z) => {
      switch (item[dict.CLIENT_GENDER]) {
        case 'MALE':
          item[dict.CLIENT_GENDER] =
            trans.CasesByGender.male[this.props.lang];
          break;
        case 'FEMALE':
          item[dict.CLIENT_GENDER] =
            trans.CasesByGender.female[this.props.lang];
          break;
        case 'TRANSGENDER':
          item[dict.CLIENT_GENDER] =
            trans.CasesByGender.trans[this.props.lang];
          break;
        case 'OTHER':
          item[dict.CLIENT_GENDER] =
            trans.CasesByGender.other[this.props.lang];
          break;
        case 'UNSPECIFIED':
          item[dict.CLIENT_GENDER] =
            trans.CasesByGender.unspecified[this.props.lang];
          break;
        default:
          break;
      }
      var itemToReturn = {
        ...item,
        index: z,
        [dict.resolved]:
          item[dict.resolved] && item[dict.resolved].toLocaleString(),
        [dict.NotResolved]:
          item[dict.NotResolved] &&
          item[dict.NotResolved].toLocaleString(),
        [dict.deaths]:
          item[dict.deaths] && item[dict.deaths].toLocaleString(),
        total: (
          item[dict.resolved] +
          item[dict.NotResolved] +
          item[dict.deaths]
        ).toLocaleString(),
      };

      return itemToReturn;
    });

    const totalCases = tableData.reduce(
      (sum, item) => sum + parseFloat(item.total.replace(/,/g, '')),
      0,
    );

    const tableDataWithPercent = tableData.map((item) => {
      return {
        ...item,
        percent:
          (
            (parseFloat(item.total.replace(/,/g, '')) / totalCases) *
            100
          ).toLocaleString() + '%',
      };
    });

    const columns = [
      {
        title: trans.CasesByGender.sex[this.props.lang],
        dataIndex: dict.CLIENT_GENDER,
        key: dict.CLIENT_GENDER,
      },
      {
        title: trans.overview.total[this.props.lang],
        dataIndex: 'total',
        key: 'total',
      },
      {
        title: trans.CasesByGender.percentages[this.props.lang],
        dataIndex: 'percent',
        key: 'percent',
      },
      {
        title: trans.CasesByGender.active[this.props.lang],
        dataIndex: dict.NotResolved,
        key: dict.NotResolved,
      },
      {
        title: trans.CasesByGender.resolved[this.props.lang],
        dataIndex: dict.resolved,
        key: dict.resolved,
      },

      {
        title: trans.CasesByGender.fatal[this.props.lang],
        dataIndex: dict.deaths,
        key: dict.deaths,
      },
    ];
    return (
      <React.Fragment>
        <Table
          columns={columns}
          dataSource={tableDataWithPercent}
          pagination={false}
        />
      </React.Fragment>
    );
  }
}

export default StackedTable;
